import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ElectricityConsumptionAndCosts, ElectricityPeriodCostAnalysisGet, GasConsumptionAndCosts, GasPeriodCostAnalysisGet, InvoicesOldestGet, LocationYearlyOverviewGet, TotalEnergyConsumptionAndCostGet, YearlyOverview, YearlyOverviewOfLocationsGet } from '../interfaces/dashboard-interfaces';
import { API_ROUTES } from './api-routes';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  constructor(private http: HttpClient) { }

  getTotalConsumptionAndCosts(year: number): Observable<any> {
    return this.http.get<TotalEnergyConsumptionAndCostGet>(
      `${API_ROUTES.DASHBOARD.TOTAL_CONSUMPTION_AND_COSTS}${year}`,
    );
  }

  getLocationsPricesOverviewPeriod(from_date: Date, to_date: Date): Observable<YearlyOverviewOfLocationsGet> {
    const params = new HttpParams()
      .set('from_date', from_date.toISOString().split('T')[0])
      .set('to_date', to_date.toISOString().split('T')[0]);

    return this.http.get<YearlyOverviewOfLocationsGet>(
      `${API_ROUTES.DASHBOARD.LOCATIONS_PRICES_OVERIVEW_PERIOD}`,
      { params }
    );
  }

  getLocationsPricesOverview(year: number, ytd: boolean | null = null): Observable<any> {
    var params = new HttpParams()
    if (ytd) {
      params = new HttpParams().set('ytd', ytd.toString());
    }

    return this.http.get<YearlyOverviewOfLocationsGet>(
      `${API_ROUTES.DASHBOARD.LOCATIONS_PRICES_OVERIVEW}${year}`,
      { params }
    );
  }

  getLocationOverview(location_id: string, year: number, ytd: boolean | null = null): Observable<any> {
    var params = new HttpParams()
    if (ytd) {
      params = new HttpParams().set('ytd', ytd.toString());
    }

    return this.http.get<LocationYearlyOverviewGet>(
      `${API_ROUTES.DASHBOARD.LOCATION}${location_id}/overview/${year}`,
      { params }
    );
  }

  getLocationPeriodOverview(location_id: string, from_date: Date, to_date: Date): Observable<any> {
    const params = new HttpParams()
      .set('from_date', from_date.toISOString().split('T')[0])
      .set('to_date', to_date.toISOString().split('T')[0]);

    return this.http.get<LocationYearlyOverviewGet>(
      `${API_ROUTES.DASHBOARD.LOCATION}${location_id}/overview/period`,
      { params }
    );
  }

  getOldestInvoice(): Observable<any> {
    return this.http.get<InvoicesOldestGet>(
      `${API_ROUTES.DASHBOARD.INVOICES_OLDEST}`,
    );
  }

  getElectricityOldestInvoice(): Observable<any> {
    return this.http.get<InvoicesOldestGet>(
      `${API_ROUTES.DASHBOARD.ELECTRICITY_INVOICES_OLDEST}`,
    );
  }

  getGasOldestInvoice(): Observable<any> {
    return this.http.get<InvoicesOldestGet>(
      `${API_ROUTES.DASHBOARD.GAS_INVOICES_OLDEST}`,
    );
  }

  getElectricityOverview(year: number, location_id: string | null = null): Observable<any> {
    let params = new HttpParams();
    if (location_id !== null) {
      params = new HttpParams().set('location_id', location_id);
    }

    return this.http.get<YearlyOverview>(
      `${API_ROUTES.DASHBOARD.ELECTRICITY_OVERVIEW}${year}`,
      { params: params }
    );
  }

  getElectricityConsumptionAndCosts(year: number): Observable<any> {
    return this.http.get<ElectricityConsumptionAndCosts>(
      `${API_ROUTES.DASHBOARD.ELECTRICITY_CONSUMPTION_AND_COSTS}${year}`,
    );
  }

  getElectricityPeriodCostAnalysis(year: number, month: number | null = null): Observable<any> {
    let params = new HttpParams();
    if (month !== null) {
      params = new HttpParams().set('month', month);
    }

    return this.http.get<ElectricityPeriodCostAnalysisGet>(
      `${API_ROUTES.DASHBOARD.ELECTRICITY_PERIOD_COSTS_ANALYSIS}${year}`,
      { params: params }
    );
  }

  getGasOverview(year: number, location_id: string | null = null): Observable<any> {
    let params = new HttpParams();
    if (location_id !== null) {
      params = new HttpParams().set('location_id', location_id);
    }

    return this.http.get<YearlyOverview>(
      `${API_ROUTES.DASHBOARD.GAS_OVERVIEW}${year}`,
      { params: params }
    );
  }

  getGasConsumptionAndCosts(year: number): Observable<any> {
    return this.http.get<GasConsumptionAndCosts>(
      `${API_ROUTES.DASHBOARD.GAS_CONSUMPTION_AND_COSTS}${year}`,
    );
  }

  getGasPeriodCostAnalysis(year: number, month: number | null = null): Observable<any> {
    let params = new HttpParams();
    if (month !== null) {
      params = new HttpParams().set('month', month);
    }

    return this.http.get<GasPeriodCostAnalysisGet>(
      `${API_ROUTES.DASHBOARD.GAS_PERIOD_COSTS_ANALYSIS}${year}`,
      { params: params }
    );
  }

  getLatestForecastInvoice(): Observable<any> {
    return this.http.get<InvoicesOldestGet>(
      `${API_ROUTES.DASHBOARD.INVOICES_LATEST_FORECAST}`,
    );
  }

  getElectricityLatestForecastInvoice(): Observable<any> {
    return this.http.get<InvoicesOldestGet>(
      `${API_ROUTES.DASHBOARD.ELECTRICITY_LATEST_FORECAST_INVOICES}`,
    );
  }

  getGasLatestForecastInvoice(): Observable<any> {
    return this.http.get<InvoicesOldestGet>(
      `${API_ROUTES.DASHBOARD.GAS_LATEST_FORECAST_INVOICES}`,
    );
  }
}
